import dayjs from 'dayjs'
import {TKey} from '@/translations/i18n'

/**
 * Date-range presets backing the "Periodo" filter select.
 *
 * Every preset resolves to a concrete `{dateFrom, dateTo}` window (YYYY-MM-DD) sent as-is
 * to the backend; `all` clears the range (no date filter).
 */
export const EXPORT_DATE_PRESETS = ['all', 'today', 'last_7_days', 'last_30_days'] as const
export type ExportDatePreset = (typeof EXPORT_DATE_PRESETS)[number]

/** Presets shown in the select, in display order. */
export const EXPORT_DATE_PRESET_OPTIONS = EXPORT_DATE_PRESETS

const PERIOD_LABEL_KEY: Record<ExportDatePreset, TKey> = {
    all: 'exports:filter_period_all',
    today: 'exports:filter_period_today',
    last_7_days: 'exports:filter_period_last_7_days',
    last_30_days: 'exports:filter_period_last_30_days'
}

export const periodLabelKey = (preset: ExportDatePreset): TKey => PERIOD_LABEL_KEY[preset]

/** Concrete `{dateFrom, dateTo}` for a preset (`all` clears the range). */
export const resolvePresetRange = (preset: ExportDatePreset): {dateFrom?: string; dateTo?: string} => {
    const today = dayjs()
    const fmt = (value: dayjs.Dayjs) => value.format('YYYY-MM-DD')

    switch (preset) {
        case 'today':
            return {dateFrom: fmt(today), dateTo: fmt(today)}
        case 'last_7_days':
            // Inclusive 7-day window (today + previous 6 days).
            return {dateFrom: fmt(today.subtract(6, 'day')), dateTo: fmt(today)}
        case 'last_30_days':
            return {dateFrom: fmt(today.subtract(29, 'day')), dateTo: fmt(today)}
        default:
            return {dateFrom: undefined, dateTo: undefined}
    }
}
